import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import { ListTable } from 'gnos-tables'
import cx from 'classnames'
import _ from 'lodash'

import CustomDate from '../../../../../../../../../../../components/CustomDate'
import NoData from '../../../../../../../../../components/Workspace/components/NoData'

import { LOCALE_PREFIX } from '../../constants'

import './style.scss'

@injectIntl
export default class CourseOfAction extends Component {
    static propTypes = {
        data: PropTypes.array,
        locked: PropTypes.bool,
        id: PropTypes.string.isRequired,
        intl: PropTypes.object,
    }

    render() {
        const { id, data, locked, intl } = this.props

        if (locked) {
            return (
                <div className={'persons-coa-block'}>
                    <NoData text={intl.formatMessage({ id: `${LOCALE_PREFIX}.lockedTab` })} />
                </div>
            )
        }

        if (_.isEmpty(data)) {
            return (
                <div className={'persons-coa-block'}>
                    <NoData text={intl.formatMessage({ id: `${LOCALE_PREFIX}.noData` })} />
                </div>
            )
        }

        return (
            <div className={'persons-coa-block'}>
                <ListTable
                    id={`persons-coa-list-table-${id}`}
                    columnsDefinition={{
                        title: {
                            width: 1,
                            Cell: () => <span>{''}</span>,
                        },
                        top: {
                            columns: [
                                {
                                    accessor: 'value',
                                    Cell: (value) => (
                                        <div
                                            className={cx(
                                                'coa-table-cell',
                                                _.get(value, 'isNested', false) && 'historic'
                                            )}
                                        >
                                            <div className={'date-container'}>
                                                {
                                                    <div className={'date-wrapper'}>
                                                        {!_.isNil(
                                                            _.get(value, 'original.dateRange.startDate.value')
                                                        ) && (
                                                            <span style={{ paddingRight: '4px' }}>
                                                                {`${intl.formatMessage({ id: 'global.date.from' })}`}
                                                            </span>
                                                        )}
                                                        <CustomDate
                                                            date={_.get(
                                                                value,
                                                                'original.dateRange.startDate.value',
                                                                null
                                                            )}
                                                            precision={_.get(
                                                                value,
                                                                'original.dateRange.startDate.precision',
                                                                null
                                                            )}
                                                        />
                                                        {!_.isNil(_.get(value, 'original.dateRange.endDate.value')) && (
                                                            <span style={{ padding: '0 4px' }}>
                                                                {`${intl.formatMessage({ id: 'global.date.to' })}`}
                                                            </span>
                                                        )}
                                                        <CustomDate
                                                            date={_.get(
                                                                value,
                                                                'original.dateRange.endDate.value',
                                                                null
                                                            )}
                                                            precision={_.get(
                                                                value,
                                                                'original.dateRange.endDate.precision',
                                                                null
                                                            )}
                                                        />
                                                    </div>
                                                }
                                            </div>
                                            <div className={'value-container'}>
                                                <span>{_.get(value, 'value', null)}</span>
                                            </div>
                                        </div>
                                    ),
                                },
                            ],
                        },
                        nested: {
                            visibleRows: 0,
                            expandText: intl.formatMessage({ id: `${LOCALE_PREFIX}.history` }),
                            columns: [
                                {
                                    accessor: 'value',
                                    Cell: (value) => (
                                        <div
                                            className={cx(
                                                'coa-table-cell',
                                                _.get(value, 'isNested', false) && 'historic'
                                            )}
                                        >
                                            <div className={'date-container'}>
                                                {
                                                    <div className={'date-wrapper'}>
                                                        <span style={{ paddingRight: '4px' }}>
                                                            {`${intl.formatMessage({ id: 'global.date.from' })}`}
                                                        </span>
                                                        <CustomDate
                                                            date={_.get(
                                                                value,
                                                                'original.dateRange.startDate.value',
                                                                null
                                                            )}
                                                            precision={_.get(
                                                                value,
                                                                'original.dateRange.startDate.precision',
                                                                null
                                                            )}
                                                        />
                                                        <span style={{ padding: '0 4px' }}>
                                                            {`${intl.formatMessage({ id: 'global.date.to' })}`}
                                                        </span>
                                                        <CustomDate
                                                            date={_.get(
                                                                value,
                                                                'original.dateRange.endDate.value',
                                                                null
                                                            )}
                                                            precision={_.get(
                                                                value,
                                                                'original.dateRange.endDate.precision',
                                                                null
                                                            )}
                                                        />
                                                    </div>
                                                }
                                            </div>
                                            <div className={'value-container'}>
                                                <span>{_.get(value, 'value', null)}</span>
                                            </div>
                                        </div>
                                    ),
                                },
                            ],
                        },
                    }}
                    staticData={{
                        _table: data,
                    }}
                    texts={{
                        loading: intl.formatMessage({ id: 'global.loading' }),
                        noData: intl.formatMessage({ id: 'global.noData' }),
                        controlExpand: intl.formatMessage({ id: 'global.controlExpand' }),
                        controlMore: intl.formatMessage({ id: 'global.controlMore' }),
                        controlLess: intl.formatMessage({ id: 'global.controlLess' }),
                        controlAll: intl.formatMessage({ id: 'global.controlAll' }),
                        controlClose: intl.formatMessage({ id: 'global.controlClose' }),
                        controlFirst: intl.formatMessage({ id: 'global.controlFirst' }),
                    }}
                />
            </div>
        )
    }
}
